
export const now = () => {
  return performance.now();
};

export default now;
